import axios from 'axios';

export const save = (videoId: string) => axios.put(
    // NOTE: This is an OWNER api, not an ADMIN api!
    '/api/pws/site-settings-section/current/homePageVideo',
    { videoId }
);
